export default {
  top: '/user/resume',
};
